// src/i18n/translations.js
// Traductions FR / EN pour toute la plateforme BET

const translations = {

  // ─────────────────────────────────────────────
  //  COMMUN
  // ─────────────────────────────────────────────
  common: {
    FR: {
      loading:        "Chargement…",
      save:           "Enregistrer",
      cancel:         "Annuler",
      close:          "Fermer",
      confirm:        "Confirmer",
      delete:         "Supprimer",
      edit:           "Modifier",
      add:            "Ajouter",
      search:         "Rechercher",
      filter:         "Filtrer",
      export:         "Exporter",
      refresh:        "Actualiser",
      back:           "Retour",
      next:           "Suivant",
      previous:       "Précédent",
      yes:            "Oui",
      no:             "Non",
      all:            "Tous",
      none:           "Aucun",
      unknown:        "Inconnu",
      success:        "Succès",
      error:          "Erreur",
      warning:        "Attention",
      info:           "Information",
      logout:         "Déconnexion",
      profile:        "Mon profil",
      settings:       "Paramètres",
      dashboard:      "Tableau de bord",
      notifications:  "Notifications",
      messages:       "Messages",
      help:           "Aide",
      contact_support:"Contacter le support",
      language:       "Langue",
    },
    EN: {
      loading:        "Loading…",
      save:           "Save",
      cancel:         "Cancel",
      close:          "Close",
      confirm:        "Confirm",
      delete:         "Delete",
      edit:           "Edit",
      add:            "Add",
      search:         "Search",
      filter:         "Filter",
      export:         "Export",
      refresh:        "Refresh",
      back:           "Back",
      next:           "Next",
      previous:       "Previous",
      yes:            "Yes",
      no:             "No",
      all:            "All",
      none:           "None",
      unknown:        "Unknown",
      success:        "Success",
      error:          "Error",
      warning:        "Warning",
      info:           "Information",
      logout:         "Log out",
      profile:        "My profile",
      settings:       "Settings",
      dashboard:      "Dashboard",
      notifications:  "Notifications",
      messages:       "Messages",
      help:           "Help",
      contact_support:"Contact support",
      language:       "Language",
    },
  },

  // ─────────────────────────────────────────────
  //  LOGIN ADMIN
  // ─────────────────────────────────────────────
  loginAdmin: {
    FR: {
      cert_center:    "Centre de formation certifié",
      headline1:      "Pilotez,",
      headline2:      "supervisez,",
      headline3:      "décidez.",
      sub:            "Accès sécurisé à l'ensemble des données et outils de gestion de la plateforme BET.",
      stat_users:     "Utilisateurs actifs",
      stat_uptime:    "Uptime du système",
      stat_sessions:  "Sessions en cours",
      stat_ssl:       "Connexion chiffrée",
      btn_staff:      "Personnel BET",
      role_select_q:  "Qui êtes-vous ? 👋",
      role_select_h:  "Sélectionnez",
      role_select_h2: "votre profil",
      role_select_d:  "Choisissez votre rôle pour accéder à votre espace.",
      pill1:"Étudiants", pill2:"Professeurs", pill3:"Finances",
      pill4:"Tests",     pill5:"Bulletins",  pill6:"RH",
      secure:         "Connexion chiffrée SSL/TLS - Zone sécurisée",
      email:          "E-mail ou téléphone",
      password:       "Mot de passe",
      forgot:         "Mot de passe oublié ?",
      login_btn:      "Se connecter →",
      logging_in:     "Connexion…",
      support:        "Problème d'accès ?",
      contact:        "Contacter le support",
      step_login_h:   "Connexion",
      step_login_s:   "sécurisée 🔐",
      step_2fa_h:     "Vérification",
      step_2fa_s:     "2FA 🛡️",
      step_enroll_h:  "Configurer",
      step_enroll_s:  "la 2FA 📱",
      desc_step1:     "Entrez vos identifiants pour accéder à votre espace.",
      desc_step2:     "Entrez le code de votre application authenticator.",
      desc_step3:     "Scannez ce QR code avec Google Authenticator ou Authy.",
      otp_hint:       "Code valable 30 secondes · Ne pas partager ce code",
      verify_btn:     "Accéder au tableau de bord →",
      verifying:      "Vérification 2FA…",
      back_ids:       "← Retour aux identifiants",
      otp_footer:     "Code de 6 chiffres dans votre application authenticator",
      secret_show:    "Saisie manuelle du code secret",
      secret_hide:    "Masquer",
      otp_confirm_h:  "Code de confirmation (6 chiffres)",
      otp_confirm_d:  "Entrez le code affiché dans votre application",
      activate_btn:   "Activer la 2FA et accéder →",
      activating:     "Activation…",
      enroll_footer:  "Utilisez Google Authenticator, Authy ou 1Password",
      change_btn:     "Changer",
      forgot_title:   "🔐 Mot de passe oublié",
      forgot_desc:    "Entrez l'adresse email de votre compte administrateur. Vous recevrez un lien pour choisir un nouveau mot de passe.",
      forgot_label:   "Adresse email",
      forgot_send:    "📨 Envoyer le lien de réinitialisation",
      forgot_sending: "Envoi en cours…",
      forgot_sent_msg:"Si cet email est enregistré, un lien de réinitialisation a été envoyé. Vérifiez votre boîte mail (et vos spams).",
      err_fields:     "Veuillez remplir tous les champs.",
      err_server:     "Impossible de joindre le serveur. Vérifiez votre connexion.",
      err_code:       "Le code doit contenir 6 chiffres.",
      err_code_inv:   "Code invalide.",
      err_email_inv:  "Veuillez saisir un email valide.",
      err_reset:      "Une erreur est survenue. Veuillez réessayer.",
    },
    EN: {
      cert_center:    "Certified training center",
      headline1:      "Manage,",
      headline2:      "supervise,",
      headline3:      "decide.",
      sub:            "Secure access to all BET platform data and management tools.",
      stat_users:     "Active users",
      stat_uptime:    "System uptime",
      stat_sessions:  "Active sessions",
      stat_ssl:       "Encrypted connection",
      btn_staff:      "BET Staff",
      role_select_q:  "Who are you? 👋",
      role_select_h:  "Select",
      role_select_h2: "your profile",
      role_select_d:  "Choose your role to access your space.",
      pill1:"Students", pill2:"Teachers", pill3:"Finances",
      pill4:"Tests",    pill5:"Reports",  pill6:"HR",
      secure:         "SSL/TLS encrypted connection - Secure zone",
      email:          "E-mail ou téléphone",
      password:       "Password",
      forgot:         "Forgot password?",
      login_btn:      "Sign in →",
      logging_in:     "Signing in…",
      support:        "Access issue?",
      contact:        "Contact support",
      step_login_h:   "Secure",
      step_login_s:   "login 🔐",
      step_2fa_h:     "2FA",
      step_2fa_s:     "verification 🛡️",
      step_enroll_h:  "Set up",
      step_enroll_s:  "2FA 📱",
      desc_step1:     "Enter your credentials to access your space.",
      desc_step2:     "Enter the code from your authenticator app.",
      desc_step3:     "Scan this QR code with Google Authenticator or Authy.",
      otp_hint:       "Valid for 30 seconds · Do not share this code",
      verify_btn:     "Access dashboard →",
      verifying:      "Verifying 2FA…",
      back_ids:       "← Back to credentials",
      otp_footer:     "6-digit code from your authenticator app",
      secret_show:    "Manual secret entry",
      secret_hide:    "Hide",
      otp_confirm_h:  "Confirmation code (6 digits)",
      otp_confirm_d:  "Enter the code shown in your app",
      activate_btn:   "Activate 2FA and continue →",
      activating:     "Activating…",
      enroll_footer:  "Use Google Authenticator, Authy or 1Password",
      change_btn:     "Change",
      forgot_title:   "🔐 Forgot password",
      forgot_desc:    "Enter your admin account email. You will receive a link to set a new password.",
      forgot_label:   "Email address",
      forgot_send:    "📨 Send reset link",
      forgot_sending: "Sending…",
      forgot_sent_msg:"If this email is registered, a reset link has been sent. Check your inbox (and spam).",
      err_fields:     "Please fill in all fields.",
      err_server:     "Cannot reach the server. Check your connection.",
      err_code:       "The code must be 6 digits.",
      err_code_inv:   "Invalid code.",
      err_email_inv:  "Please enter a valid email.",
      err_reset:      "An error occurred. Please try again.",
    },
  },

  // ─────────────────────────────────────────────
  //  LOGIN APPRENANT
  // ─────────────────────────────────────────────
  loginApprenant: {
    FR: {
      cert_center:    "Centre de formation certifié",
      headline1:      "Apprenez,",
      headline2:      "progressez,",
      headline3:      "certifiez‑vous.",
      sub:            "Accédez à vos cours, suivez votre progression et obtenez vos certifications reconnues.",
      stat_users:     "Apprenants actifs",
      stat_success:   "Taux de réussite",
      stat_access:    "Accès plateforme",
      stat_levels:    "Tous niveaux",
      pill1:"Cours en ligne", pill2:"Suivi personnalisé", pill3:"Certifications",
      pill4:"Ressources",     pill5:"Tests de niveau",   pill6:"Bulletins",
      role_label:     "Espace Apprenant",
      welcome:        "Bienvenue 👋",
      title1:         "Connectez‑vous",
      title2:         "à votre espace",
      desc:           "Accédez à vos formations et suivez votre progression.",
      secure:         "🔒 Connexion chiffrée SSL/TLS - Zone sécurisée",
      email:          "Email",
      email_ph:       "votre.email@exemple.com",
      password:       "Mot de passe",
      forgot:         "Mot de passe oublié ?",
      login_btn:      "Accéder à mon espace →",
      logging_in:     "Connexion…",
      no_account:     "Pas encore inscrit ?",
      contact:        "Contactez votre responsable",
      btn_apprenant:  "Apprenant",
      btn_parent:     "Parent / Enfant",
      btn_staff:      "Personnel BET",
      forgot_title:   "🔐 Mot de passe oublié",
      forgot_desc:    "Entrez l'adresse email de votre compte. Vous recevrez un lien pour choisir un nouveau mot de passe.",
      forgot_label:   "Adresse email",
      forgot_send:    "📨 Envoyer le lien de réinitialisation",
      forgot_sending: "Envoi…",
      forgot_sent_msg:"Si cet email est enregistré, un lien de réinitialisation a été envoyé. Vérifiez votre boîte mail (et vos spams).",
      err_fields:     "Veuillez remplir tous les champs.",
      err_server:     "Impossible de joindre le serveur. Vérifiez votre connexion.",
      err_email_inv:  "Veuillez saisir un email valide.",
      err_reset:      "Une erreur est survenue. Veuillez réessayer.",
    },
    EN: {
      cert_center:    "Certified training center",
      headline1:      "Learn,",
      headline2:      "progress,",
      headline3:      "get certified.",
      sub:            "Access your courses, track your progress and earn recognized certifications.",
      stat_users:     "Active learners",
      stat_success:   "Success rate",
      stat_access:    "Platform access",
      stat_levels:    "All levels",
      pill1:"Online courses", pill2:"Personalised support", pill3:"Certifications",
      pill4:"Resources",      pill5:"Level tests",          pill6:"Report cards",
      role_label:     "Learner Space",
      welcome:        "Welcome 👋",
      title1:         "Sign in",
      title2:         "to your space",
      desc:           "Access your courses and track your progress.",
      secure:         "🔒 SSL/TLS encrypted connection - Secure zone",
      email:          "Email",
      email_ph:       "your.email@example.com",
      password:       "Password",
      forgot:         "Forgot password?",
      login_btn:      "Access my space →",
      logging_in:     "Signing in…",
      no_account:     "Not yet enrolled?",
      contact:        "Contact your coordinator",
      btn_apprenant:  "Learner",
      btn_parent:     "Parent / Child",
      btn_staff:      "BET Staff",
      forgot_title:   "🔐 Forgot password",
      forgot_desc:    "Enter your account email. You will receive a link to set a new password.",
      forgot_label:   "Email address",
      forgot_send:    "📨 Send reset link",
      forgot_sending: "Sending…",
      forgot_sent_msg:"If this email is registered, a reset link has been sent. Check your inbox (and spam).",
      err_fields:     "Please fill in all fields.",
      err_server:     "Cannot reach the server. Check your connection.",
      err_email_inv:  "Please enter a valid email.",
      err_reset:      "An error occurred. Please try again.",
    },
  },

  // ─────────────────────────────────────────────
  //  LOGIN PARTICULIER (PARENT / ENFANT)
  // ─────────────────────────────────────────────
  loginParticulier: {
    FR: {
      cert_center:    "Centre de formation certifié",
      headline1:      "Suivez,",
      headline2:      "encouragez,",
      headline3:      "réussissez.",
      sub:            "Un espace dédié aux familles pour accompagner chaque apprenant dans sa progression en anglais.",
      stat_families:  "Familles inscrites",
      stat_satisf:    "Taux de satisfaction",
      stat_access:    "Accès au suivi",
      stat_ages:      "Ans, tous niveaux",
      pill1:"Suivi en temps réel", pill2:"Bulletins",     pill3:"Progression",
      pill4:"Évaluations",         pill5:"Devoirs",       pill6:"Résultats",
      role_label:     "Espace Famille",
      welcome:        "Bienvenue 👋",
      who_title:      "Qui êtes‑vous ?",
      who_desc:       "Sélectionnez votre profil pour accéder à votre espace.",
      parent_label:   "Parent / Tuteur",
      parent_desc:    "Suivez la progression de votre enfant",
      child_label:    "Enfant / Étudiant",
      child_desc:     "Accédez à vos cours et activités",
      no_account:     "Pas de compte ?",
      contact_center: "Contacter le centre",
      login_title:    "Connexion",
      login_sub:      "sécurisée 🔐",
      login_desc:     "Entrez vos identifiants pour accéder à votre espace.",
      change_btn:     "Changer",
      secure:         "🔒 Connexion chiffrée SSL/TLS - Zone sécurisée",
      email:          "Email",
      email_ph:       "votre.email@exemple.com",
      password:       "Mot de passe",
      forgot:         "Mot de passe oublié ?",
      login_btn:      "Accéder à mon espace →",
      logging_in:     "Connexion…",
      support:        "Problème d'accès ?",
      contact:        "Contacter le support",
      connect_child:  "🎒 Connecter mon enfant à son espace",
      btn_apprenant:  "Apprenant",
      btn_parent:     "Parent / Enfant",
      btn_staff:      "Personnel BET",
      forgot_title:   "🔐 Mot de passe oublié",
      forgot_desc:    "Entrez l'adresse email de votre compte. Vous recevrez un lien pour choisir un nouveau mot de passe.",
      forgot_label:   "Adresse email",
      forgot_send:    "📨 Envoyer le lien de réinitialisation",
      forgot_sending: "Envoi…",
      forgot_sent_msg:"Si cet email est enregistré, un lien de réinitialisation a été envoyé. Vérifiez votre boîte mail (et vos spams).",
      err_fields:     "Veuillez remplir tous les champs.",
      err_server:     "Impossible de joindre le serveur. Vérifiez votre connexion.",
      err_email_inv:  "Veuillez saisir un email valide.",
      err_reset:      "Une erreur est survenue. Veuillez réessayer.",
    },
    EN: {
      cert_center:    "Certified training center",
      headline1:      "Track,",
      headline2:      "encourage,",
      headline3:      "succeed.",
      sub:            "A dedicated family space to support every learner's progress in English.",
      stat_families:  "Enrolled families",
      stat_satisf:    "Satisfaction rate",
      stat_access:    "Progress access",
      stat_ages:      "Years old, all levels",
      pill1:"Real-time tracking", pill2:"Report cards", pill3:"Progress",
      pill4:"Assessments",        pill5:"Homework",     pill6:"Results",
      role_label:     "Family Space",
      welcome:        "Welcome 👋",
      who_title:      "Who are you?",
      who_desc:       "Select your profile to access your space.",
      parent_label:   "Parent / Guardian",
      parent_desc:    "Track your child's progress",
      child_label:    "Child / Student",
      child_desc:     "Access your courses and activities",
      no_account:     "No account?",
      contact_center: "Contact the center",
      login_title:    "Secure",
      login_sub:      "login 🔐",
      login_desc:     "Enter your credentials to access your space.",
      change_btn:     "Change",
      secure:         "🔒 SSL/TLS encrypted connection - Secure zone",
      email:          "Email",
      email_ph:       "your.email@example.com",
      password:       "Password",
      forgot:         "Forgot password?",
      login_btn:      "Access my space →",
      logging_in:     "Signing in…",
      support:        "Access issue?",
      contact:        "Contact support",
      connect_child:  "🎒 Connect my child to their space",
      btn_apprenant:  "Learner",
      btn_parent:     "Parent / Child",
      btn_staff:      "BET Staff",
      forgot_title:   "🔐 Forgot password",
      forgot_desc:    "Enter your account email. You will receive a link to set a new password.",
      forgot_label:   "Email address",
      forgot_send:    "📨 Send reset link",
      forgot_sending: "Sending…",
      forgot_sent_msg:"If this email is registered, a reset link has been sent. Check your inbox (and spam).",
      err_fields:     "Please fill in all fields.",
      err_server:     "Cannot reach the server. Check your connection.",
      err_email_inv:  "Please enter a valid email.",
      err_reset:      "An error occurred. Please try again.",
    },
  },

  // ─────────────────────────────────────────────
  //  LOGIN PROFESSEUR
  // ─────────────────────────────────────────────
  loginProfesseur: {
    FR: {
      cert_center:    "Centre de formation certifié",
      headline1:      "Enseignez,",
      headline2:      "inspirez,",
      headline3:      "transformez.",
      sub:            "Accédez à vos classes, gérez vos cours et suivez la progression de vos apprenants.",
      stat_coaches:   "Professeurs actifs",
      stat_classes:   "Classes en cours",
      stat_access:    "Accès plateforme",
      stat_avg:       "Satisfaction moyenne",
      pill1:"Mes classes", pill2:"Planning", pill3:"Ressources pédagogiques",
      pill4:"Suivi apprenants", pill5:"Évaluations",
      role_label:     "Espace Professeur",
      welcome:        "Bienvenue 👋",
      title1:         "Connectez‑vous",
      title2:         "à votre espace",
      desc:           "Accédez à vos classes et gérez vos cours.",
      secure:         "🔒 Connexion chiffrée SSL/TLS - Zone sécurisée",
      email:          "Email",
      email_ph:       "prof@bet-formation.com",
      password:       "Mot de passe",
      forgot:         "Mot de passe oublié ?",
      login_btn:      "Accéder à mon espace →",
      logging_in:     "Connexion…",
      no_account:     "Problème d'accès ?",
      contact:        "Contacter l'administration",
      btn_apprenant:  "Apprenant",
      btn_prof:       "Professeur",
      btn_staff:      "Personnel BET",
      forgot_title:   "🔐 Mot de passe oublié",
      forgot_desc:    "Entrez l'adresse email de votre compte. Vous recevrez un lien pour choisir un nouveau mot de passe.",
      forgot_label:   "Adresse email",
      forgot_send:    "📨 Envoyer le lien de réinitialisation",
      forgot_sending: "Envoi…",
      forgot_sent_msg:"Si cet email est enregistré, un lien de réinitialisation a été envoyé. Vérifiez votre boîte mail (et vos spams).",
      err_fields:     "Veuillez remplir tous les champs.",
      err_server:     "Impossible de joindre le serveur. Vérifiez votre connexion.",
      err_role:       "Accès refusé - ce compte n'est pas un compte coach BET.",
      err_email_inv:  "Veuillez saisir un email valide.",
      err_reset:      "Une erreur est survenue. Veuillez réessayer.",
    },
    EN: {
      cert_center:    "Certified training center",
      headline1:      "Teach,",
      headline2:      "inspire,",
      headline3:      "transform.",
      sub:            "Access your classes, manage your courses and track your learners' progress.",
      stat_coaches:   "Active teachers",
      stat_classes:   "Classes in progress",
      stat_access:    "Platform access",
      stat_avg:       "Average satisfaction",
      pill1:"My classes", pill2:"Schedule", pill3:"Teaching resources",
      pill4:"Learner tracking", pill5:"Assessments",
      role_label:     "Teacher Space",
      welcome:        "Welcome 👋",
      title1:         "Sign in",
      title2:         "to your space",
      desc:           "Access your classes and manage your courses.",
      secure:         "🔒 SSL/TLS encrypted connection - Secure zone",
      email:          "Email",
      email_ph:       "prof@bet-formation.com",
      password:       "Password",
      forgot:         "Forgot password?",
      login_btn:      "Access my space →",
      logging_in:     "Signing in…",
      no_account:     "Access issue?",
      contact:        "Contact administration",
      btn_apprenant:  "Learner",
      btn_prof:       "Teacher",
      btn_staff:      "BET Staff",
      forgot_title:   "🔐 Forgot password",
      forgot_desc:    "Enter your account email. You will receive a link to set a new password.",
      forgot_label:   "Email address",
      forgot_send:    "📨 Send reset link",
      forgot_sending: "Sending…",
      forgot_sent_msg:"If this email is registered, a reset link has been sent. Check your inbox (and spam).",
      err_fields:     "Please fill in all fields.",
      err_server:     "Cannot reach the server. Check your connection.",
      err_role:       "Access denied - this account is not a BET coach account.",
      err_email_inv:  "Please enter a valid email.",
      err_reset:      "An error occurred. Please try again.",
    },
  },

  // ─────────────────────────────────────────────
  //  DASHBOARDS - ÉLÉMENTS COMMUNS
  // ─────────────────────────────────────────────
  dashboard: {
    FR: {
      welcome:         "Bienvenue",
      my_space:        "Mon espace",
      students:        "Étudiants",
      teachers:        "Professeurs",
      classes:         "Classes",
      courses:         "Cours",
      exams:           "Examens",
      results:         "Résultats",
      schedule:        "Planning",
      payments:        "Paiements",
      invoices:        "Factures",
      reports:         "Rapports",
      statistics:      "Statistiques",
      attendance:      "Présences",
      grades:          "Notes",
      certificates:    "Certificats",
      resources:       "Ressources",
      homework:        "Devoirs",
      progress:        "Progression",
      level:           "Niveau",
      sessions:        "Séances",
      center:          "Centre",
      group:           "Groupe",
      staff:           "Personnel",
      contracts:       "Contrats",
      hr:              "Ressources humaines",
      accounting:      "Comptabilité",
      crm:             "CRM",
      enrollments:     "Inscriptions",
      active:          "Actif",
      inactive:        "Inactif",
      pending:         "En attente",
      completed:       "Terminé",
      in_progress:     "En cours",
      total:           "Total",
      today:           "Aujourd'hui",
      this_week:       "Cette semaine",
      this_month:      "Ce mois",
      view_all:        "Voir tout",
      see_more:        "Voir plus",
      last_update:     "Dernière mise à jour",
      no_data:         "Aucune donnée disponible",
      logout_confirm:  "Êtes-vous sûr de vouloir vous déconnecter ?",
    },
    EN: {
      welcome:         "Welcome",
      my_space:        "My space",
      students:        "Students",
      teachers:        "Teachers",
      classes:         "Classes",
      courses:         "Courses",
      exams:           "Exams",
      results:         "Results",
      schedule:        "Schedule",
      payments:        "Payments",
      invoices:        "Invoices",
      reports:         "Reports",
      statistics:      "Statistics",
      attendance:      "Attendance",
      grades:          "Grades",
      certificates:    "Certificates",
      resources:       "Resources",
      homework:        "Homework",
      progress:        "Progress",
      level:           "Level",
      sessions:        "Sessions",
      center:          "Centre",
      group:           "Group",
      staff:           "Staff",
      contracts:       "Contracts",
      hr:              "Human Resources",
      accounting:      "Accounting",
      crm:             "CRM",
      enrollments:     "Enrollments",
      active:          "Active",
      inactive:        "Inactive",
      pending:         "Pending",
      completed:       "Completed",
      in_progress:     "In progress",
      total:           "Total",
      today:           "Today",
      this_week:       "This week",
      this_month:      "This month",
      view_all:        "View all",
      see_more:        "See more",
      last_update:     "Last update",
      no_data:         "No data available",
      logout_confirm:  "Are you sure you want to log out?",
    },
  },

  /* ─────────────────────────────────────────────
     LES PROFILS DU PERSONNEL — page de connexion

     Ils vivaient en dur dans `PROFILS_BET`, une constante de MODULE de `LoginAdmin.jsx` :
     construite à l'importation du fichier, elle ne pouvait pas appeler `t()`, qui vient
     d'un hook. Les dix-sept libellés et leurs descriptions restaient donc français même
     en anglais — ce que le bascule FR/EN rendait visible, puisque tout le reste suivait.

     Les clés portent l'identifiant du profil, pas son libellé : renommer « Gestionnaire »
     ne cassera rien ici.
     ───────────────────────────────────────────── */
  profils: {
    FR: {
      super_admin:           "Super Admin",
      admin:                 "Administrateur",
      manager:               "Manager",
      superviseur:           "Superviseur Global",
      deputy_superviseur:    "Deputy Superviseur",
      pedagogical_advisor:   "Conseiller Pédagogique",
      commercial:            "Commercial",
      onboarding:            "Onboarding",
      gestionnaire:          "Gestionnaire",
      rh:                    "RH",
      comptable:             "Comptable",
      coach:                 "Coach",
      customer_care:         "Customer Care",
      assistant_sav:         "Assistante SAV",
      data_collector:        "Data Collector",
      placement_test:        "Agent Placement Test",
      marketing:             "Assistant Marketing",
    },
    EN: {
      super_admin:           "Super Admin",
      admin:                 "Administrator",
      manager:               "Manager",
      superviseur:           "Global Supervisor",
      deputy_superviseur:    "Deputy Supervisor",
      pedagogical_advisor:   "Educational Advisor",
      commercial:            "Sales",
      onboarding:            "Onboarding",
      gestionnaire:          "Manager",
      rh:                    "RH",
      comptable:             "Accountant",
      coach:                 "Coach",
      customer_care:         "Customer Care",
      assistant_sav:         "Customer Service Assistant",
      data_collector:        "Data Collector",
      placement_test:        "Placement Test Administrator",
      marketing:             "Marketing Assistant",
    },
  },

  profilsDesc: {
    FR: {
      super_admin:           "Accès total à la plateforme",
      admin:                 "Gestion complète",
      manager:               "Supervision & reporting",
      superviseur:           "Contrôle & supervision globale",
      deputy_superviseur:    "Supervision déléguée par centre",
      pedagogical_advisor:   "Classes privées & honoraires",
      commercial:            "CRM & inscriptions",
      onboarding:            "Accueil & intégration",
      gestionnaire:          "Administratif & finances",
      rh:                    "Ressources humaines & paie",
      comptable:             "Comptabilité & trésorerie",
      coach:                 "Cours & étudiants",
      customer_care:         "Support & fidélisation client",
      assistant_sav:         "Service après-vente",
      data_collector:        "Saisie de données",
      placement_test:        "Validation tests de niveau",
      marketing:             "Gestion du site web & contenu",
    },
    EN: {
      super_admin:           "Full access to the platform",
      admin:                 "Comprehensive Management",
      manager:               "Oversight & Reporting",
      superviseur:           "Overall Control & Oversight",
      deputy_superviseur:    "Delegated supervision by center",
      pedagogical_advisor:   "Private Lessons & Fees",
      commercial:            "CRM & Registration",
      onboarding:            "Welcome & Integration",
      gestionnaire:          "Administration & Finance",
      rh:                    "Human Resources & Payroll",
      comptable:             "Accounting & Cash Management",
      coach:                 "Courses & Students",
      customer_care:         "Customer Support & Loyalty",
      assistant_sav:         "Customer Service",
      data_collector:        "Data Entry",
      placement_test:        "Validation of Proficiency Tests",
      marketing:             "Website & Content Management",
    },
  },
};

export default translations;
